import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { collection, doc, getDocs, getFirestore, updateDoc } from "firebase/firestore";

const firestore = getFirestore();

export const fetchPricing = createAsyncThunk("pricing/fetchPricing", async () => {
  const snapshot = await getDocs(collection(firestore, "pricing"));
  return snapshot.docs.map((document) => ({ id: document.id, ...document.data() }));
});

export const updatePricing = createAsyncThunk(
  "pricing/updatePricing",
  async ({ id, pricePerHead }) => {
    const pricingDoc = doc(firestore, "pricing", id);
    await updateDoc(pricingDoc, { pricePerHead });
    return { id, pricePerHead };
  }
);

const pricingSlice = createSlice({
  name: "pricing",
  initialState: {
    items: [],
    status: "idle",
    error: null,
    updateStatus: {},
  },
  reducers: {
    clearUpdateStatus: (state, action) => {
      const id = action.payload;
      if (id) {
        delete state.updateStatus[id];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPricing.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPricing.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
        state.updateStatus = {};
      })
      .addCase(fetchPricing.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updatePricing.pending, (state, action) => {
        const id = action.meta.arg.id;
        state.updateStatus[id] = { status: "pending" };
      })
      .addCase(updatePricing.fulfilled, (state, action) => {
        const { id, pricePerHead } = action.payload;
        const index = state.items.findIndex((item) => item.id === id);
        if (index !== -1) {
          state.items[index].pricePerHead = pricePerHead;
        }
        state.updateStatus[id] = { status: "succeeded" };
      })
      .addCase(updatePricing.rejected, (state, action) => {
        const id = action.meta.arg.id;
        state.updateStatus[id] = {
          status: "failed",
          error: action.error.message,
        };
      });
  },
});

export const { clearUpdateStatus } = pricingSlice.actions;

export default pricingSlice.reducer;
